<template>
  <div>
    <v-card
      flat
      v-if="observation.message"
      width="100%"
      class="rounded-lg grey lighten-4"
    >
      <v-card-text class="text--primary">
        <v-card flat class="rounded-lg">
          <v-card-text class="text--primary">
            <div class="mb-1 d-flex justify-space-between">
              <div>
                <v-icon small class="mt-n1 mr-1">mdi-account-circle</v-icon>
                {{
                  observation.user.id == currentUser.id
                    ? "Tú"
                    : observation.user.email
                }}
              </div>
              <div class="d-flex align-center" style="gap: 4px">
                {{ new Date(observation.createdAt).toLocaleDateString() }}

                <delete
                  @reload="$emit('reload')"
                  v-if="observation.user.id == currentUser.id"
                  :id="observation.id"
                ></delete>
              </div>
            </div>

            <div class="body-1">
              {{ observation.message }}
            </div>
          </v-card-text>
        </v-card>

        <div
          class="pt-4 font-weight-medium d-flex justify-space-between align-center"
          style="cursor: pointer"
          @click="expanded = !expanded"
        >
          <div>Ver comentarios ({{ observation.comments.length }})</div>

          <div>
            <v-icon class="mt-n1"
              >mdi-chevron-{{ expanded ? "up" : "down" }}</v-icon
            >
          </div>
        </div>

        <v-expand-transition>
          <div v-if="expanded">
            <div v-if="!observation.comments.length">
              <v-card flat width="100%" class="rounded-lg ml-auto">
                <v-card-text class="text--primary">
                  Aún no hay comentarios relacionados a esta observación.
                </v-card-text>
              </v-card>
            </div>

            <div class="d-flex" style="gap: 12px" v-else>
              <v-divider vertical> </v-divider>
              <div class="grow">
                <template v-for="comment in observation.comments">
                  <v-card flat width="100%" class="rounded-lg mt-2 ml-auto">
                    <v-card-text class="text--primary">
                      <div class="caption d-flex">
                        <div>
                          <v-icon small class="mt-n1 mr-1"
                            >mdi-account-circle</v-icon
                          >
                          {{
                            comment.user.id == currentUser.id
                              ? "Tú"
                              : comment.user.email
                          }}
                        </div>

                        <v-spacer></v-spacer>

                        <div class="d-flex align-center" style="gap: 4px">
                          {{ new Date(comment.createdAt).toLocaleDateString() }}

                          <delete-comment
                            @reload="$emit('reload')"
                            v-if="comment.user.id == currentUser.id"
                            :id="comment.id"
                          ></delete-comment>
                        </div>
                      </div>

                      <div class="py-1">
                        {{ comment.text }}
                      </div>
                    </v-card-text>
                  </v-card>
                </template>
              </div>
            </div>

            <div class="py-3">
              <v-textarea
                v-model="newComment"
                outlined
                rows="2"
                placeholder="Escriba un comentario aquí..."
                class="rounded-lg"
                append-icon="mdi-send"
                @click:append="create"
                @keyup.enter="create"
                style="background-color: white"
                hide-details
              ></v-textarea>
            </div>
          </div>
        </v-expand-transition>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { CreateObservationComment } from "@/graphql/mutations/properties";
import Delete from "./actions/Delete";
import DeleteComment from "./actions/DeleteComment";

export default {
  data: () => ({
    expanded: false,
    newComment: null
  }),

  props: {
    observation: {
      required: true,
      type: Object
    }
  },

  computed: {
    ...mapGetters(["currentUser"])
  },

  methods: {
    create() {
      if (this.newComment)
        this.$apollo
          .mutate({
            mutation: CreateObservationComment,
            variables: {
              input: {
                attributes: {
                  text: this.newComment,
                  observationId: this.observation.id
                }
              }
            }
          })
          .then(res => {
            this.newComment = null;
            this.$emit("reload");
          });
    }
  },

  components: {
    Delete,
    DeleteComment
  }
};
</script>
